import { useEffect, useState } from "react";

const useImageDimensions = (url: string) => {
  const [width, setWidth] = useState("");
  const [height, setHeight] = useState("");

  useEffect(() => {
    if (!url) {
      return;
    }
    const image = new Image();
    image.src = url;
    image.onload = () => {
      setWidth(image.width.toFixed(0));
      setHeight(image.height.toFixed(0));
    };
  }, [url]);

  return { width, height };
};

export default useImageDimensions;
